// import { useQuery } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'api/axios';
import axios from 'axios';
import endpoints from '../aiBlogWriterEndPoints';

export function useFormOptions() {
  return useQuery({
    queryKey: ['blogMeta'],
    queryFn: async () => {
      try {
        const { data } = await axiosInstance.public.get(
          endpoints.getBlogFormOptions
        );
        return {
          industries: data.data.industries,
          languages: data.data.languages,
          tones: data.data.tones,
        };
      } catch (error) {
        if (axios.isAxiosError(error)) {
          throw new Error(error.response?.data?.message || 'An error occurred');
        }
        throw error;
      }
    },
  });
}
